<script setup>
import Layout from '../../Layouts/Guest.vue';
import { Head, useForm } from "@inertiajs/inertia-vue3";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { computed, ref } from "vue";

const props = defineProps({
    email: {
        type: String,
        required: true,
    },
    token: {
        type: String,
        required: true,
    },
});

const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
});

const hasError = computed(() => {
    return form.errors.password || form.errors.email
})

const error = computed(() => {
    if (form.errors?.password) {
        return form.errors.password[0]
    }

    return form.errors.email[0]
})

const submit = () => {
    form.post('/reset-password', {
        onFinish: () => {
            form.reset('password', 'password_confirmation')
        },
    });
};


</script>

<template>
    <Layout>
        <Head title="Reset Password" />

        <div class="max-w-[600px] flex-1">
            <h3 class="text-2xl text-primary mb-4">Passwort zurücksetzen</h3>

            <form @submit.prevent="submit">
                <div class="mb-4">
                    <InputText
                        id="password"
                        type="password"
                        class="w-full"
                        v-model="form.password"
                        required
                        placeholder="Passwort"
                    />

                    <span v-if="hasError" class="text-error text-sm">
                            {{ error }}
                        </span>
                </div>

                <div class="mb-4">
                    <InputText
                        id="password_confirmation"
                        type="password"
                        class="w-full"
                        v-model="form.password_confirmation"
                        required
                        placeholder="Passwort bestätigen"
                    />
                </div>

                <div>
                    <Button
                        :disabled="form.processing"
                        :loading="form.processing"
                        type="submit"
                        class="w-full bg-[#FFF053] text-black border-none cursor-pointer"
                        label="Speichern"
                    />
                </div>
            </form>
        </div>
    </Layout>
</template>
